import css from './menu.module.scss';

import { memo } from 'react';

import Button from '../Button';
import KeyBind from '../KeyBind';
import { TStrKeyBind } from '../KeyBind/keyUtils';
import { Icon as IconCore } from '../icons';
import { useCloseMenu } from './context';

type Props = {
  label: string;
  icon: TIconComponent;
  disabled?: boolean;
  onClick: () => Promise<void> | void;
  kkb?: TStrKeyBind;
  active?: boolean;
};

const MenuItem = ({
  label,
  onClick,
  icon: Icon,
  disabled = false,
  kkb,
  active = false,
}: Props) => {
  const close = useCloseMenu();

  return (
    <Button
      disabled={disabled}
      className={active ? css.active : undefined}
      theme="menuItem"
      onClick={() => {
        close();
        void onClick();
      }}
    >
      {kkb && <KeyBind kkb={kkb} onKeyUp={onClick} />}
      <div className={css.menuItemContent}>
        {Icon && <Icon className={css.icon} />}
        <span className={css.label}>{label}</span>
        {kkb && <span className={css.keyBind}>{kkb}</span>}
        {active && <IconCore icon="Active" className={css.activeIcon} />}
      </div>
    </Button>
  );
};

export default memo(MenuItem);
